import axios from 'axios';
import {StatsUpdateEventDTO, WriteMpCampaignDTO} from "./types";
import {createOrUpdatePetitionFetchCounter} from "./createOrUpdatePetitionFetchCounter";

export function pollForNewEmails(
    campaign: WriteMpCampaignDTO,
    times: number,
    sinceTs: string,
    sinceId: number,
    startFn: () => void = () => {
    },
): void {
    if (campaign.showLoopControl) {
        createOrUpdatePetitionFetchCounter(campaign, startFn, times);
    }
    if (times <= 0) return null;
    setTimeout(async () => {
            const response = await axios.get(`/petitions/${campaign.petition.slug}/emails_since`, {
                params: {
                    sinceTs: sinceTs,
                    sinceId: sinceId,
                }
            });
            const last_email = response.data.emails.length ? response.data.emails[response.data.emails.length - 1] : null;
            const emailsEvent = new CustomEvent<StatsUpdateEventDTO>('stats.update', {detail: response.data});
            document.dispatchEvent(emailsEvent);
            pollForNewEmails(
                campaign,
                --times,
                last_email ? last_email.created_at : sinceTs,
                last_email ? last_email.id : sinceId,
                startFn,
            );
        },
        campaign.ui.poll_for_emails_interval
    );
}
